import { MouseEventHandler } from "react";
import { Box, Typography } from "@bca/ui-library";
import { useSelector } from "react-redux";

import CloseButton from "./CloseButton";
import FilterCategories from "./FilterCategories";
import ApplyFiltersFooter from "./ApplyFiltersFooter";
import { StoreType } from "../StoreType";
import { GET_STATE } from "../redux/slices/appSlice";

const FiltersBarMobile: React.FunctionComponent<{
  onClose: MouseEventHandler<HTMLButtonElement>;
  setSelectedVehicles: (selectedVehicles: string[]) => void;
  appliedCheckboxes;
  setAppliedCheckboxes;
  filtersCount;
  onClearAllFilters;
  resultCount;
  searchResultsLoading: boolean;
}> = ({
  onClose,
  setSelectedVehicles,
  appliedCheckboxes,
  setAppliedCheckboxes,
  filtersCount,
  onClearAllFilters,
  resultCount,
  searchResultsLoading,
}) => {
  const {
    app: { totalTracked },
  }: StoreType = useSelector(GET_STATE);

  return (
    <Box
      as="aside"
      width="100%"
      height="100%"
      px={5}
      py={6}
      backgroundColor="primary-white"
    >
      <Box display="flex" flexDirection="row" pb={7}>
        <Typography variant="h4" my={0}>
          Filters
        </Typography>
        <CloseButton onClick={onClose} />
      </Box>
      <FilterCategories
        setSelectedVehicles={setSelectedVehicles}
        appliedCheckboxes={appliedCheckboxes}
        setAppliedCheckboxes={setAppliedCheckboxes}
        searchResultsLoading={searchResultsLoading}
      />
      <ApplyFiltersFooter
        filtersCount={filtersCount}
        onClearAllFilters={onClearAllFilters}
        resultCount={resultCount}
        onClose={onClose}
        totalTracked={totalTracked}
      />
    </Box>
  );
};

export default FiltersBarMobile;
